
import React from 'react';

interface OrderSummaryProps {
  selectedOffer: 'standard' | 'premium' | 'exclusive';
  offerPrice: number;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ selectedOffer, offerPrice }) => {
  return (
    <div className="bg-primary/5 rounded-lg p-4 mb-6">
      <p className="font-medium">Wybrany pakiet: <span className="text-primary">
        {selectedOffer === 'standard' ? 'Standard' : selectedOffer === 'premium' ? 'Premium' : 'Exclusive'}
      </span></p>
      <p className="font-medium">Wartość zamówienia: <span className="text-primary">{offerPrice.toLocaleString('pl-PL')} PLN</span></p>
    </div>
  );
};

export default OrderSummary;
